class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty') || document.getElementById('CartDrawer')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.renderCartDrawerContents(parsedState);
    this.renderCartIconBubble(parsedState);
    this.playCelebration();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  renderCartDrawerContents(parsedState) {
    const html = parsedState.sections && parsedState.sections['cart-drawer'];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    ['.rb-cd__title', '#CartDrawer-CartItems', '.rb-cd__summary'].forEach((selector) => {
      this.replaceElementFromSection(doc, selector);
    });
    this.syncUpsellFromSection(doc, parsedState.item_count);
    this.pruneUpsell(parsedState);
    if (typeof parsedState.item_count === 'number') this.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  renderCartIconBubble(parsedState) {
    const html = parsedState.sections && parsedState.sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (html && bubble) bubble.innerHTML = this.getSectionInnerHTML(html);
  }

  replaceElementFromSection(doc, selector) {
    const target = this.querySelector(selector);
    const source = doc.querySelector(selector);
    if (target && source) target.replaceWith(source);
  }

  syncUpsellFromSection(doc, itemCount) {
    const current = this.querySelector('#rb-yml');
    if (itemCount === 0) {
      if (current) current.remove();
      return;
    }
    if (!current) {
      const source = doc.getElementById('rb-yml');
      const anchor = this.querySelector('.rb-cd__summary');
      if (source && anchor) anchor.insertAdjacentElement('beforebegin', source);
    }
  }

  pruneUpsell(parsedState) {
    if (!parsedState || !Array.isArray(parsedState.items)) return;
    parsedState.items.forEach((item) => {
      const card = this.querySelector(`.rb-yml__card[data-product-id="${item.product_id}"]`);
      if (!card || card.classList.contains('is-added')) return;
      card.classList.add('is-added');
      setTimeout(() => {
        const list = card.closest('.rb-yml__list');
        const wrap = card.closest('.rb-yml');
        card.remove();
        if (list && !list.querySelector('.rb-yml__card') && wrap) wrap.remove();
      }, 180);
    });
  }

  playCelebration() {
    this.classList.remove('is-celebrating');
    void this.offsetWidth;
    this.classList.add('is-celebrating');
    window.clearTimeout(this.rbCelebrateTimer);
    this.rbCelebrateTimer = window.setTimeout(() => {
      this.classList.remove('is-celebrating');
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer-CartItems',
        section: 'cart-drawer',
        selector: '#CartDrawer-CartItems',
      },
      {
        id: 'rb-cd-summary',
        section: 'cart-drawer',
        selector: '.rb-cd__summary',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.rb-cd__title',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
